import React from "react"
import TransitionFade from "./transition-fade"
import PropTypes from "prop-types"
import { useAllContent } from "../hooks/use-all-content"
import { useAllTaxo } from "../hooks/use-all-taxo"

const entityLinkParser = {
  external: {
    regex: /^(http|https):/,
    parser: (children, regex, link, allData, allTaxo, attributes) => {
      return (
        <a rel="noreferrer" target="_blank" href={link} {...attributes}>
          {children}
        </a>
      )
    },
  },
  internal: {
    regex: /internal:\/(?!node|taxo)/,
    parser: (children, regex, link, allData, allTaxo, attributes) => {
      return (
        <TransitionFade link={link.replace(regex, "/")} {...attributes}>
          {children}
        </TransitionFade>
      )
    },
  },
  node: {
    regex: /entity:node\/(\d+)/,
    parser: (children, regex, link, allData, allTaxo, attributes) => {
      const drupalId = link.match(regex)[1]
      const processedNode = allData
        .filter(
          ({ node }) => node.drupal_internal__nid == drupalId // eslint-disable-line eqeqeq
        )
        .shift()
      if (processedNode) {
        return (
          <TransitionFade link={processedNode.node.path.alias} {...attributes}>
            {children}
          </TransitionFade>
        )
      }
      return null
    },
  },
  taxonomy: {
    regex: /internal:\/taxonomy\/term\/(\d+)/,
    parser: (children, regex, link, allData, allTaxo, attributes) => {
      const drupalId = link.match(regex)[1]
      const processedNode = allTaxo
        .filter(
          ({ node }) => node.drupal_internal__tid == drupalId // eslint-disable-line eqeqeq
        )
        .shift()
      if (processedNode) {
        return (
          <TransitionFade link={processedNode.node.path.alias}>
            {children}
          </TransitionFade>
        )
      }
      return null
    },
  },
  nolink: {
    regex: /^route:<nolink>$/,
    parser: (children, regex, link, allData, allTaxo) => {
      return <>{children}</>
    },
  },
}

const ProcessedLink = ({ children, link, attributes }) => {
  const allData = useAllContent()
  const allTaxo = useAllTaxo()
  for (const linkType in entityLinkParser) {
    const typeDef = entityLinkParser[linkType]
    if (typeDef.regex.test(link)) {
      link = typeDef.parser(
        children,
        typeDef.regex,
        link,
        allData,
        allTaxo,
        attributes
      )
    }
  }
  return link
}

ProcessedLink.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string.isRequired,
  allData: PropTypes.array,
  allTaxo: PropTypes.array,
  attributes: PropTypes.object,
}

export default ProcessedLink
